// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__3KSK1","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__2msju"};